import { Component, inject } from '@angular/core';

import { ButtonModule, DIALOG_DATA, DialogRef } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { DialogData } from '@pp/core/entities';

@Component({
  selector: 'pp-reach-limit',
  imports: [ButtonModule, TranslateModule],
  templateUrl: './reach-limit.component.html',
  styleUrl: './reach-limit.component.scss',
})
export class ReachLimitComponent {
  dialogRef = inject(DialogRef);
  dialog = inject<DialogData<ReachLimitComponent, { text: string }>>(DIALOG_DATA);
}
